import { attempt } from "@omni/utils/function.utils";

const LEFT = "<!--";
const RIGHT = "-->";

const parseElementForCommentedContent = (element: HTMLElement | null) => {
    if (!element) {
        return undefined;
    }
    return attempt(() => {
        const payload = element.innerHTML;
        const jsonPayload = payload.slice(
            LEFT.length,
            payload.length - RIGHT.length
        );
        return JSON.parse(jsonPayload);
    }, {});
};

export { parseElementForCommentedContent };
